var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3225 2.25C8.50604 2.25 5.40462 5.35143 5.40462 9.16785C5.40462 13.7086 11.1432 20.1343 11.3846 20.4036C11.626 20.6729 11.9696 20.8214 12.3225 20.8214C12.6753 20.8214 13.0189 20.6729 13.2603 20.4036C13.8732 19.7257 19.2403 13.6064 19.2403 9.16785C19.2403 5.35143 16.1389 2.25 12.3225 2.25ZM12.3225 19.3636C11.5703 18.4907 6.79747 12.8821 6.79747 9.16785C6.79747 6.12214 9.27676 3.64286 12.3225 3.64286C15.3682 3.64286 17.8475 6.12214 17.8475 9.16785C17.8475 12.3064 14.291 17.135 12.3225 19.3636Z",
    fill: "#959FA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7311 2.25C8.88901 2.25 5.76677 5.5065 5.76677 9.51375C5.76677 14.2815 11.5439 21.0285 11.7869 21.3113C12.03 21.594 12.3758 21.75 12.7311 21.75C13.0863 21.75 13.4322 21.594 13.6752 21.3113C14.2922 20.5995 19.6953 14.1742 19.6953 9.51375C19.6953 5.5065 16.5731 2.25 12.7311 2.25ZM9.81447 9.51375C9.81447 7.83675 11.1232 6.47175 12.7311 6.47175C14.3389 6.47175 15.6476 7.83675 15.6476 9.51375C15.6476 11.1907 14.3389 12.5558 12.7311 12.5558C11.1232 12.5558 9.81447 11.1907 9.81447 9.51375Z",
    fill: "#959FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGrey);
export default __webpack_public_path__ + "static/media/locationGrey.a7d2a0c29c0c78dab714a01caf3b59a6.svg";
export { ForwardRef as ReactComponent };